import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useVATStore } from '../../stores/VATStore';
import { relationships } from '../../services/Relashionships';


const EndUserDetails = () => {

  const [endUserFirstName, setEndUserFirstName] = useState<string>('');
  const [endUserTelephone, setEndUserTelephone] = useState<string>('');
  const [endUserlastName, setEndUserlastName] = useState<string>('');
  const [endUserZip, setEndUserZip] = useState<string>('');

  const { error, setFormValue, vatFormErrors, newCustomerForm } = useVATStore();
  const handleIamServiceUserChange = (event: React.ChangeEvent<HTMLInputElement>) => { setIamServiceUser(event.target.checked); };
  const [iamServiceUser, setIamServiceUser] = useState(false);
  const [selectedRelashionship, setSelectedRelashionship] = useState<{ value: string; label: string; } | null>(null);
  const [otherRelashionship, setOtherRelashionship] = useState<string>('');

  useEffect(() => {
    if (newCustomerForm) {
      setIamServiceUser(newCustomerForm.relationship ? false : true);
      setEndUserFirstName(newCustomerForm.end_user?.first_name || '');
      setEndUserlastName(newCustomerForm.end_user?.last_name || '');
      setEndUserTelephone(newCustomerForm.end_user?.telephone || '');
      setEndUserZip(newCustomerForm.end_user?.zip || '');
  
      if (!newCustomerForm.iamserviceuser && newCustomerForm.relationship) {
        setSelectedRelashionship({ value: newCustomerForm.relationship, label: newCustomerForm.relationship });
      }
      if (!newCustomerForm.iamserviceuser && newCustomerForm.other_relationship) {
        setOtherRelashionship(newCustomerForm.other_relationship);
      }
    }
  }, [newCustomerForm]);

  useEffect(() => {
    setFormValue('end_user', [], { first_name: endUserFirstName ?? '', last_name: endUserlastName ?? '', zip: endUserZip ?? '', telephone: endUserTelephone ?? '' });
    setFormValue('relationship', [], selectedRelashionship?.value ?? '');
    setFormValue('other_relationship', [], otherRelashionship ?? '');
    setFormValue('iamserviceuser', [], iamServiceUser);
  }, [ endUserFirstName, endUserlastName, endUserTelephone, endUserZip, selectedRelashionship, otherRelashionship, iamServiceUser]);


  return (
    <div className="simple-form">
      <h2 className='ncf-title'>Your Details</h2>
      <span className='ncf-subtitle'>Tick the following box if this applies to you.</span>

      <div className='form-line checkbox-and-input negative-margin'>
        <div className='input-group'>
          <label className="custom-checkbox">
            <input type="checkbox"
              checked={iamServiceUser}
              onChange={handleIamServiceUserChange}
            />
            <span></span>
            I am the alarm service user and I will pay for the service.
          </label>
        </div>
      </div>
      {!iamServiceUser ?
        <div className='form-line'>
          <div className='medical-conditions-wrap input-group left'>
            <Select
              options={relationships.map(t => ({ value: t, label: t }))}
              value={selectedRelashionship}
              className={vatFormErrors.length && vatFormErrors.includes('relationship') ? ' input-ncf error-required' : 'input-ncf'}
              onChange={(selectedOption) => { setSelectedRelashionship(selectedOption); }}
            />
            <label className='placeholder'>Your relationship with alarm user*</label>
          </div>
          {selectedRelashionship?.value === 'Other' ?
            <div className='input-group right'>
              <input
                type="text"
                value={otherRelashionship}
                className={vatFormErrors.length && vatFormErrors.includes('other_relashionship') ? 'input-ncf error-required' : 'input-ncf'}
                onChange={(e) => setOtherRelashionship(e.target.value)}
              />
              <label className='placeholder'>Other Relationship*</label>
            </div>
            : ''}
        </div> : ''}
      <div className="margin-bottom margin-top">
        <div className='margin-bottom'>
          <label className='ncf-title'>Alarm User Details</label>
        </div>
        <div className='form-line'>
          <div className='input-group left'>
            <input
              type="text"
              value={endUserFirstName}
              className={vatFormErrors.length && vatFormErrors.includes('enduser_firstname') ? 'input-ncf error-required' : 'input-ncf'}
              onChange={(e) => setEndUserFirstName(e.target.value)}
            />
            <label className='placeholder'>First Name*</label>
          </div>
          <div className='input-group right'>
            <input
              type="text"
              className={vatFormErrors.length && vatFormErrors.includes('enduser_lastname') ? 'input-ncf error-required' : 'input-ncf'}
              value={endUserlastName}
              onChange={(e) => setEndUserlastName(e.target.value)}
            />
            <label className='placeholder'>Last name*</label>
          </div>
        </div>
        <div className='form-line margin-top'>
          <div className='input-group left'>
            <input
              type="text"
              value={endUserZip}
               className={vatFormErrors.length && vatFormErrors.includes('enduser_zip') ? 'input-ncf error-required' : 'input-ncf'}
              onChange={(e) => setEndUserZip((e.target.value ?? '').toUpperCase())}
            />
            <label className='placeholder'>Postcode*</label>
          </div>
        </div>
        <div className='form-line margin-top'>
          <div className='input-group left'>
            <div className="input-wrapper prefix-input-wrapper">
              <span className="bit-prefix">+44</span>
              <input
                type="text"
                value={endUserTelephone}
                 className={vatFormErrors.length && vatFormErrors.includes('enduser_firstname') ? 'input-ncf error-required' : 'input-ncf'}
                onChange={(e) => setEndUserTelephone(e.target.value)}
              />
            </div>
            <label className='placeholder'>Telephone*</label>
          </div>
        </div>
      </div>

      {error !== '' ? <div className="error">{error}</div> : ''}
    </div>
  );
};

export default EndUserDetails;